import { render, staticRenderFns } from "./BomInfo.vue?vue&type=template&id=0a3bbdcb&"
import script from "./BomInfo.vue?vue&type=script&lang=js&"
export * from "./BomInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports